/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_No_EligibleInputs */



/**
* | output |
* | --- |
* | "No eligible players in this pool" |
*
* @param {Raffle_No_EligibleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_no_eligible = /** @type {((inputs?: Raffle_No_EligibleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_No_EligibleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun joueur éligible dans ce pool")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay jugadores elegibles en este pool")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum jogador elegível neste pool")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun giocatore idoneo in questo pool")
	return /** @type {LocalizedString} */ ("No eligible players in this pool")
});